import { CookieConsent } from '@/components/popups/CookieConsent'
import { CourseLandingDark } from '@/components/variants/pages/course-dark'

const CourseLanding = () => {
  return <CourseLandingDark></CourseLandingDark>
}

// @ts-ignore
CourseLanding.getLayout = function getLayout(page) {
  return (
    <>
      {page}
      <CookieConsent/>
    </>
  )
}

export default CourseLanding
